// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import './common/style/element/index.css'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'


import urls from './common/js/urls.js'

import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)

//post传参序列化(添加请求拦截器)
axios.interceptors.request.use(function (config) {
  //在发送请求之前做某件事
  if (config.method === 'post') {
    //配置请求头
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return config;
}, function (error) {
  return Promise.reject(error);
})


axios.interceptors.response.use(function (config) {
  // Do something before request is sent
  store.dispatch("onLoading", false);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})


/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  // store.dispatch("onLoading", true);
   next()
})
// 这里为了让效果明显一些加了延时
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
  if (to.name == "login") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "forget") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "register") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "download") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "PersonalOrderList") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "PersonalBalance") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "PersonalVoucher") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "PersonalQuiz") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "about") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "DryMain") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "testresults") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "SubjectId") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "pictureTool") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "information") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "quizDetail") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "quiz") {
    store.dispatch("onLoading", false);
  }
  if (to.name == "introduce") {
    store.dispatch("onLoading", false);
  }
  //
})

Vue.config.productionTip = false

// 用 axios 进行 Ajax 请求
Vue.use(VueAxios, axios);
//element-ui
Vue.use(ElementUI);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js